// Lib
import HttpStatus from 'http-status-codes';

// Utils
import { getResponseStatusCode, getErrorName } from '../../utils/errorUtil';

type ExportErrorTranslation = { key: string; defaultText: string };

export const getExportErrorText = (err: unknown): ExportErrorTranslation => {
    const statusCode = getResponseStatusCode(err);

    if (statusCode === HttpStatus.TOO_MANY_REQUESTS)
        return { key: 'errors.tooManyRequests', defaultText: 'Failed - please wait 20 seconds' };

    const errorName = getErrorName(err);

    if (errorName === 'LimitExceededError')
        return { key: 'errors.limitExceeded', defaultText: 'Too many cards to export' };

    return { key: 'errors.failedToCreateExport', defaultText: 'Failed to create export' };
};
